import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';

import capitalizeFirstLetter from './utils/CapitalizeFirstLetters';
import ProfileModal from './ProfileModal';
import Ponto from './Ponto';
import WorkActivity from '../WorkActivity/WorkActivity';
import Logo from '../../assets/images/puntu-logo3.svg';
import Notification from './notification';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {

    display: 'flex',
  },

  button: {
    borderRadius: '20px',
    margin: '5px',
    '&:hover': {
      color: '#537CCD',
      backgroundColor: '#FFF',
    },
    logo: {
      width: '20px',
    },
    fontWeight: 'bold',
  },
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),
    textAlign: 'left',
  },
  toolbar: {
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
});

function HeaderEmployee(props) {
  const { classes, children, user } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [open, setOpen] = React.useState(false);
  const [openPonto, setOpenPonto] = React.useState(false);

  const [selectedValue, setSelectedValue] = React.useState(null);
  const [selectedValuePonto, setSelectedValuePonto] = React.useState(null);


  function handleClickOpen() {
    setOpen(true);
  }

  function handleClickOpenPonto() {
    setOpenPonto(true);
  }
  const handleCloseProfile = (value) => {
    setAnchorEl(null);
    setOpen(false);
    setSelectedValue(value);
  };

  const handleClosePonto = (value) => {
    setOpenPonto(false);
    setSelectedValuePonto(value);
  };

  const handleClick = (event) => {
    if (!anchorEl) { setAnchorEl(event.currentTarget); }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getName = (employeeName) => {
    if (employeeName) {
      const index = employeeName.indexOf(' ');
      if (index > 0) { return capitalizeFirstLetter(employeeName.slice(0, index)); }
      return capitalizeFirstLetter(employeeName);
    }
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">

        <Toolbar>
          <Grid container spacing={5}>
            <Grid item xs={8} style={{ display: 'flex' }}>

              <img src={Logo} alt="Puntu" style={{ width: 100 }} />

            </Grid>


            <Grid item xs={4} style={{ justifyContent: 'flex-end', display: 'flex', alignItems: 'center' }}>

              <WorkActivity />
              <Button variant="outlined" onClick={handleClickOpenPonto} size="medium" color="inherit" className={classes.button}>Bater Ponto</Button>
              <Notification />
              <Ponto name={user} selectedValue={selectedValuePonto} open={openPonto} onClose={handleClosePonto} />

              {getName(user)}
              <IconButton
                aria-owns={anchorEl ? 'simple-menu' : undefined}
                color="inherit"
                aria-haspopup="true"
                onClick={handleClick}
              >

                <ExpandMore />

                <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                  <MenuItem onClick={handleClickOpen}>Perfil</MenuItem>
                  <MenuItem>
                    <Link style={{ textDecoration: 'none', color: 'rgba(0, 0, 0, 0.87)' }} to="/logout/funcionario">
                      Sair
                    </Link>
                  </MenuItem>
                </Menu>
                <ProfileModal selectedValue={selectedValue} open={open} onClose={handleCloseProfile} />
              </IconButton>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <main className={classes.content}>
        {children}
      </main>
    </div>
  );
}

HeaderEmployee.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HeaderEmployee);
